import { Divider } from '@mui/material';
import React, { useContext } from 'react';
import './modal.css';

const BrandsData = ({ pageData }) => {
  return (
    <div className="modal-body-brands">
      <div
        className="modal-body-allign"
        style={{
          display: 'flex',
          justifyContent: 'flex-start',
          color: '#003cc5',
          gap: '35%',
        }}
      >
        <div>
          <h6 style={{ color: '#003cc5' }}>{pageData?.standardLbl}</h6>
          <Divider
            style={{
              borderColor: '#003cc5',
              borderWidth: '1px',
              marginBottom: '5px',
              marginTop: '5px',
            }}
          />
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              gap: '50px',
            }}
          >
            <div>
              {pageData?.brandsStandardArray?.map(
                (brand, index) =>
                  index < pageData?.brandsStandardArray?.length / 2 && (
                    <p
                      style={{
                        padding: '0px',
                        color: '#003cc5',
                        fontSize: '16px',
                      }}
                      key={index}
                    >
                      {brand}
                    </p>
                  )
              )}
            </div>
            <div>
              {pageData?.brandsStandardArray?.map(
                (brand, index) =>
                  index >= pageData?.brandsStandardArray?.length / 2 && (
                    <p
                      style={{
                        padding: '0px',
                        color: '#003cc5',
                        fontSize: '16px',
                      }}
                      key={index}
                    >
                      {brand}
                    </p>
                  )
              )}
            </div>
          </div>
        </div>
        <div>
          <h6 style={{ color: '#003cc5' }}>{pageData?.luxaryLbl}</h6>
          <Divider
            style={{
              borderColor: '#003cc5',
              borderWidth: '1px',
              marginBottom: '5px',
              marginTop: '5px',
            }}
          />
          {pageData?.brandsLuxuryArray?.map((brand, index) => (
            <p
              style={{ padding: '0px', color: '#003cc5', fontSize: '16px' }}
              key={index}
            >
              {brand}
            </p>
          ))}
        </div>
      </div>
      <p className="modal-footer-note">
        <sup>*</sup> {pageData?.brandsCoveredNote}
      </p>
    </div>
  );
};

export default BrandsData;
